import * as React from 'react';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails, { AccordionDetailsProps } from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { Box, Divider, styled } from '@mui/material';
import { Radio } from 'components/common/radio';

const Accordion = styled((props: AccordionProps) => <MuiAccordion square {...props} />)(({ theme }) => ({
  borderRadius: '3px',
  background: '#FFFFFF',
  marginBottom: '2px',
  boxShadow: 'none',
  padding: '10px 0px',
  ':before': { backgroundColor: 'transparent' },
}));

const AccordionDetails = styled((props: AccordionDetailsProps) => <MuiAccordionDetails {...props} />)(({ theme }) => ({
  paddingTop: '0px',
}));

interface PaymentTypeProps {
  title: string;
  summary: React.ReactElement;
  content: React.ReactElement;
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const PaymentType = ({ title, summary, content, expanded, onChange }: PaymentTypeProps) => {
  return (
    <Accordion expanded={expanded} onChange={onChange}>
      <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
        <Box width="55%" display="flex">
          <Radio checked={!!expanded} />
          <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'left' }}>
            {title}
          </Typography>
        </Box>
        <Box width="45%" display="flex" textAlign="right" alignItems="center" justifyContent="right">
          {summary}
        </Box>
      </AccordionSummary>
      <Divider sx={{ color: '#BDBDBD', margin: '0 10px 20px' }} />
      <AccordionDetails>{content}</AccordionDetails>
    </Accordion>
  );
};

export default PaymentType;
